<div class="dx-fieldset">
  <div class="dx-field">
    <h5>{{ 'Update Template' | translate }}</h5>
  </div>

  <div class="dx-field">
    <div class="dx-field-label jobListTD">{{ 'Name' | translate }}</div>
    <div class="dx-field-value {{showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
      <label class="placeLabel {{ modelService.updateTemplateService.selectedTemplate.name?.length>0 ? 'placeLabelSmall' : '' }}">NAME</label>
      <dx-text-box [(value)]="modelService.updateTemplateService.selectedTemplate.name" [showClearButton]="true" (onValueChanged)="update($event)"></dx-text-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">{{ 'Neue Varianten von vorhandenen Produkten übernehmen' | translate }}</div>
    <div class="dx-field-value">
      <dx-switch (onValueChanged)="update($event)" [(value)]="modelService.updateTemplateService.selectedTemplate.addNewChilds" switchedOffText="{{ 'Nein' | translate }}" switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">{{ 'Leere Werte in der Quelle ignorieren' | translate }}</div>
    <div class="dx-field-value">
      <dx-switch (onValueChanged)="update($event)" [(value)]="modelService.updateTemplateService.selectedTemplate.ignoreEmptyValues" switchedOffText="{{ 'Nein' | translate }}" switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
    </div>
  </div>

  <div class="dx-field">
    <h5>{{ 'Felder' | translate }}</h5>
  </div>
  <div class="dx-field">
    <dx-tile-view class="dx-tile-content excelFields" [baseItemWidth]="285" direction="vertical" width="100%" height="100%" baseItemHeight="15">
      <dxi-item *ngFor="let group of groups"
                [widthRatio]="1"
                [heightRatio]="getHeightRatio(group)">
        <div class="p-1 pb-3">
          <dx-check-box [value]="isGroupSelected(group)"
                        (onValueChanged)="changedField($event,group)"
                        style="float:left;padding-right:10px;">
          </dx-check-box>
          <b>{{group}}</b>
        </div>
        <div *ngFor="let field of modelService.updateTemplateService.selectedTemplate.items">
          <div *ngIf="field.group==group" style="height:35px">
            <div style="width:40px;float:left;padding-left:10px;">
              <dx-check-box [(value)]="field.isActive" (onValueChanged)="update($event)" [readOnly]="readOnly(field.field)"></dx-check-box>
            </div>
            <label class="exportLabel">{{field.field}}</label>
            <div style="width:calc(100% - 30px);margin-left:40px;" class="exportText">

              <div class="d-flex">

                <div>
                  {{ field.field | translate }}
                </div>

                <div *ngIf="field.field=='MIME_UPDATE_MODE'" class="ml-3">
                  <div id="activeMIME" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activeMIME" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl Medien übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen Medien geloscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die Medien, die im Quellkatalog bereits existieren, uberschrieben. Nur im Zielkatalog vorhandene Medien werden nicht geandert.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist die ORDER-Nummer.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>

                <div *ngIf="field.field=='FEATURE_UPDATE_MODE'" class="ml-3">
                  <div id="activeFEATURE" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activeFEATURE" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl Features übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen Features geloscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die Features, die im Quellkatalog bereits existieren, uberschrieben. Nur im Zielkatalog vorhandene Features werden nicht geandert.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist die der Feature Name in Kombination mit der Einheit.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>

                <div *ngIf="field.field=='PRICE_UPDATE_MODE'" class="ml-3">
                  <div id="activePRICE" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activePRICE" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl Preise übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen Preise geloscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die Preise, die im Quellkatalog bereits existieren, uberschrieben. Nur im Zielkatalog vorhandene Preise werden nicht geandert.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist die ORDER-Nummer.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>

                <div *ngIf="field.field=='UDX_UPDATE_MODE'" class="ml-3">
                  <div id="activeUDX" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activeUDX" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl UDX übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen UDX geloscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die UDX, die im Quellkatalog bereits existieren, uberschrieben. Nur im Zielkatalog vorhandene UDX werden nicht geandert.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist die ORDER-Nummer.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>


                <div *ngIf="field.field=='CATEGORY_UPDATE_MODE'" class="ml-3">
                  <div id="activeCategory" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activeCategory" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl Kategorien übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen Kategorien gelöscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die Kategorien, die im Quellkatalog bereits existieren, uberschrieben und neue hinzugefügt. Nur im Zielkatalog vorhandene Kategorien bleiben bestehen.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist der GROUP_STRING.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>
                <div *ngIf="field.field=='STATUS_UPDATE_MODE'" class="ml-3">
                  <div id="activeStatus" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activeStatus" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl Status übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen Status gelöscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die Status, die im Quellkatalog bereits existieren, uberschrieben und Neue hinzugefügt. Nur im Zielkatalog vorhandene Status bleiben bestehen.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist die Status Text.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>
                <div *ngIf="field.field=='SUPPLIER_UPDATE_MODE'" class="ml-3">
                  <div id="activeStatus" class="dx-link dx-icon-info dx-link-icon infoBadgeStyle"></div>
                  <dx-tooltip target="#activeStatus" showEvent="dxhoverstart" hideEvent="dxhoverend">
                    <div *dxTemplate="let data of 'content'">
                      <p>
                        {{ 'Ist der Update Modus inaktiv, obwohl Lieferanten übertragen werden sollen, werden zu Beginn des Updates die im Zielkatalog vorhandenen Lieferanten gelöscht und aus dem Quellkatalog neu angelegt.' | translate }}
                      </p>
                      <p>
                        {{ 'Ist der Update Modus aktiv, werden beim Update im Zielkatalog nur die Lieferanten, die im Quellkatalog bereits existieren, uberschrieben und Neue hinzugefügt. Nur im Zielkatalog vorhandene Lieferanten bleiben bestehen.' | translate }}
                      </p>
                      <p>
                        {{ 'Unterscheidungsmerkmal ist die Lieferanten-Nr. in Verbindung mit dem gültig ab Datum.' | translate }}
                      </p>
                    </div>
                  </dx-tooltip>
                </div>
              </div>

            </div>
          </div>
        </div>

      </dxi-item>
    </dx-tile-view>
  </div>
</div>


 


